import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="w-full" style={{ backgroundColor: "#1A1A1A", color: "#F4EEE6" }}>
      <div className="mx-auto max-w-content px-5 md:px-12 lg:px-16">
        <div className="pt-16 pb-12 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2 max-w-[380px]">
            <Link to="/" className="flex items-baseline gap-[3px] cursor-pointer">
              <span className="font-serif-display font-normal text-[26px] leading-none tracking-[-0.01em]" style={{ color: "#FFFFFF" }}>Atelier</span>
              <span className="font-serif-display italic font-light text-[26px] leading-none tracking-[-0.01em]" style={{ color: "rgba(255,255,255,0.65)" }}>Ridge</span>
            </Link>
            <p className="mt-6 leading-[1.65]" style={{ fontSize: "15px", color: "rgba(244,238,230,0.65)" }}>
              Residential design + build studio composing calm, crafted homes across Southern California.
            </p>
          </div>
          <div>
            <span className="eyebrow" style={{ color: "rgba(244,238,230,0.55)" }}>Studio</span>
            <ul className="mt-5 flex flex-col gap-3 text-[14px]" style={{ color: "rgba(244,238,230,0.85)" }}>
              <li><Link to="/studio" className="hover:text-white cursor-pointer">About</Link></li>
              <li><Link to="/process" className="hover:text-white cursor-pointer">Process</Link></li>
              <li><Link to="/projects" className="hover:text-white cursor-pointer">Projects</Link></li>
              <li><Link to="/contact" className="hover:text-white cursor-pointer">Contact</Link></li>
            </ul>
          </div>
          <div>
            <span className="eyebrow" style={{ color: "rgba(244,238,230,0.55)" }}>Services</span>
            <ul className="mt-5 flex flex-col gap-3 text-[14px]" style={{ color: "rgba(244,238,230,0.85)" }}>
              <li><Link to="/services/whole-home" className="hover:text-white cursor-pointer">Whole Home</Link></li>
              <li><Link to="/services/kitchens" className="hover:text-white cursor-pointer">Kitchens</Link></li>
              <li><Link to="/services/bathrooms" className="hover:text-white cursor-pointer">Bathrooms</Link></li>
              <li><Link to="/services/additions" className="hover:text-white cursor-pointer">Additions</Link></li>
            </ul>
          </div>
        </div>
        <div className="py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4" style={{ borderTop: "1px solid rgba(244,238,230,0.15)" }}>
          <span className="eyebrow" style={{ color: "rgba(244,238,230,0.55)" }}>© 2026 Atelier Ridge</span>
          <span className="eyebrow" style={{ color: "rgba(244,238,230,0.55)" }}>Los Angeles · Ojai · By Appointment</span>
        </div>
      </div>
    </footer>
  );
}